import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withResizeDetector } from 'react-resize-detector';

import { receiveAppType } from '../../../actions/appActions';
import { getQueryParameters } from '../../../util/utils';

import PollContainer from '../../poll/pollContainer';

const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        receiveAppType: (type) => dispatch(receiveAppType(type)),
    }
};

class PollApp extends React.Component {
    constructor(props) {
        super(props);

        this.inline = +getQueryParameters(this.props.location.search).in === 1 ? true : false;
        this.appType = 'Inline Poll';
    }

    componentDidMount() {
        this.props.receiveAppType(this.appType);
    }

    componentDidUpdate(prevProps) {
        if(window.hlPostHeight && this.inline) {
            window.hlPostHeight(this.props.height);
        }
    }

    render() {
        return (
            <div className='main-app'>
                <PollContainer />
            </div>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withResizeDetector(PollApp)));